import { carrotClient } from "#/utils/CarrotClient"
import { createSessionKeepAlive } from "./createSessionKeepAlive"
import { useSessionKeepAlive } from "./useSessionKeepAlive"

// Module-level, so the throttle is per tab and survives remounts.
const sessionKeepAlive = createSessionKeepAlive({ ping: () => carrotClient.keepSessionAlive() })

export function SessionKeepAlive({ isLoggedIn }: { isLoggedIn: boolean }): null {
  useSessionKeepAlive(sessionKeepAlive, isLoggedIn)
  return null
}
